import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h4","key":"svg-2"}],["path",{"d":"M22 22l-5 -5m0 5l5 -5","key":"svg-3"}]]

const IconFilter2X = createReactComponent('outline', 'filter-2-x', 'Filter2X', __iconNode);

export default IconFilter2X;